import { apiRequest } from "@/lib/api";

export type PriceBookItemType = "LABOR" | "MATERIAL" | "EQUIPMENT" | "OTHER";
export type PriceBookPricingMode = "TRACK_UNITS" | "NO_UNITS";

export type PriceBookItem = {
  id: string;
  name: string;
  type: PriceBookItemType;
  description?: string | null;
  thumbnailPath?: string | null;
  thumbnailUrl?: string | null;
  unit?: string | null;
  pricingMode: PriceBookPricingMode;
  defaultPrice: number;
  archivedAt?: string | null;
  createdAt: string;
  updatedAt: string;
};

export function fetchPriceBookItems(filters: {
  search?: string;
  type?: PriceBookItemType | "";
  includeArchived?: boolean;
} = {}) {
  const params = new URLSearchParams();
  if (filters.search?.trim()) params.set("search", filters.search.trim());
  if (filters.type) params.set("type", filters.type);
  if (filters.includeArchived) params.set("includeArchived", "true");
  const query = params.toString();
  return apiRequest<PriceBookItem[]>(`/price-book${query ? `?${query}` : ""}`, { method: "GET" });
}

export function createPriceBookItem(payload: {
  name: string;
  type: PriceBookItemType;
  description?: string;
  thumbnailDataUrl?: string;
  unit?: string;
  pricingMode: PriceBookPricingMode;
  defaultPrice: number;
}) {
  return apiRequest<PriceBookItem>("/price-book", {
    method: "POST",
    body: payload,
  });
}

export function updatePriceBookItem(
  id: string,
  payload: {
    name: string;
    type: PriceBookItemType;
    description?: string;
    thumbnailDataUrl?: string;
    removeThumbnail?: boolean;
    unit?: string;
    pricingMode: PriceBookPricingMode;
    defaultPrice: number;
  },
) {
  return apiRequest<PriceBookItem>(`/price-book/${id}`, {
    method: "PATCH",
    body: payload,
  });
}

export function archivePriceBookItem(id: string) {
  return apiRequest<PriceBookItem>(`/price-book/${id}`, {
    method: "DELETE",
  });
}

export function removePriceBookItem(id: string) {
  return apiRequest<{ success: boolean }>(`/price-book/${id}/permanent`, {
    method: "DELETE",
  });
}

export function importDefaultPriceBookItems() {
  return apiRequest<{
    companyType: string;
    importedCount: number;
    skippedCount: number;
    totalDefaults: number;
  }>("/price-book/import-defaults", {
    method: "POST",
    body: {},
  });
}
